
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
export default {
    name: 'App',
    components: {
        Header,
        Footer,
    },
    metaInfo: {
        title: 'France Urgence Seniors',
        // titleTemplate: '%s | Maison de retraite',
        htmlAttrs: {
            lang: 'fr',
        },
        meta: [
            { charset: 'utf-8' },
            {
                name: 'description',
                content: 'France Urgence Seniors',
            },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { name: 'robots', content: 'index,follow' },
            { name: 'googlebot', content: 'index,follow' },
            { name: 'google', content: 'nositelinkssearchbox' },
        ],
        link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
    },
};
